// Server-backed auth for the Vokentra console.
// login() exchanges credentials at the backend /login endpoint for a JWT, which
// is then attached to every /api request (see installAuthFetch in main.tsx) and
// validated server-side. This is a real security boundary, not a UI-only gate.

const API = '/api/agents';
const TOKEN_KEY = 'vokentra_token';
const USER_KEY = 'vokentra_user';

function decodeExp(token: string): number {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.exp === 'number' ? payload.exp : 0;
  } catch {
    return 0;
  }
}

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function isAuthenticated(): boolean {
  const t = getToken();
  if (!t) return false;
  const exp = decodeExp(t);
  return exp === 0 ? true : exp * 1000 > Date.now(); // valid until expiry
}

export async function login(username: string, password: string): Promise<boolean> {
  try {
    const r = await fetch(`${API}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: username.trim(), password }),
    });
    if (!r.ok) return false;
    const d = await r.json();
    if (!d.token) return false;
    localStorage.setItem(TOKEN_KEY, d.token);
    localStorage.setItem(USER_KEY, d.user || username.trim());
    return true;
  } catch {
    return false;
  }
}

export function currentUser(): string {
  try {
    return localStorage.getItem(USER_KEY) || 'user';
  } catch {
    return 'user';
  }
}

// The demo account sees a restricted console (Dashboard, Voice Call, Transcripts).
export function isDemo(): boolean {
  return currentUser().toLowerCase() === 'demo';
}

// Routes (under /app) the demo account is allowed to access.
export const DEMO_ALLOWED = ['', 'voice', 'transcripts'];

export function logout(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  } catch {
    /* ignore */
  }
}
